import axios from "axios";
import {
    FAQS_LIST_REQUEST,
    FAQS_POLICY_LIST_SUCCESS,
    FAQS_POLICY_LIST_FAIL,
    FAQS_POLICY_DETAILS_REQUEST,
    FAQS_POLICY_DETAILS_SUCCESS,
    FAQS_POLICY_DETAILS_FAIL
} from "../constants/categoryConstants";
import { BASE_URL, FAQS_URL } from "../api";

export const listFaqs = () => async (dispatch) => {
  try {
    dispatch({ type: FAQS_LIST_REQUEST });
    const { data } = await axios.get(BASE_URL+FAQS_URL);
    dispatch({
      type: FAQS_POLICY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FAQS_POLICY_LIST_FAIL,
      
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};



export const listLocationDetails =(id) => async (dispatch)=>{

  try{
      dispatch({type:FAQS_POLICY_DETAILS_REQUEST})
      const {data} = await axios.get(`/api/products/${id}`)

      dispatch({
          type:FAQS_POLICY_DETAILS_SUCCESS,
          payload:data
      })

  }
  catch(error){
      dispatch({
          type:FAQS_POLICY_DETAILS_FAIL,
          payload:error.response && error.response.data.detail
          ? error.response.data.detail
          :error.message,
      })

  }
}